/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentPriorityCommandPriorityMax = 4;

export const incidentPriorityCommandExpectedVersionExclusiveMin = 0;
export const incidentPriorityCommandExpectedVersionMax = 9007199254740991;

export const IncidentPriorityCommand = zod.object({
  priority: zod.int().min(1).max(incidentPriorityCommandPriorityMax),
  expectedVersion: zod
    .int()
    .gt(incidentPriorityCommandExpectedVersionExclusiveMin)
    .max(incidentPriorityCommandExpectedVersionMax),
});

export type IncidentPriorityCommand = zod.input<typeof IncidentPriorityCommand>;
export type IncidentPriorityCommandOutput = zod.output<typeof IncidentPriorityCommand>;
